export const MainColor = "#036AAF";
export const TabletSize = 1023;
export const MobileSize = 767;
